// test2340
(2340 && 0);
